export default {
  bind: (el, binding) => {
    if (el.tagName !== 'INPUT') {
      el = el.querySelector('input')
    }

    if (binding.value) {
      el.setAttribute('pattern', binding.value)
    }
  },
}
